import type {
  ValidationRule,
} from "libs/utils/validators/src/lib/validationRules";

import { createFieldValidator } from "../../error/createFieldValidator";
import type { IErrorStore } from "../../error/types";
import type { TCatFormDataInput } from "@./suf-store";
import type { RequiredFieldData } from "./baseStore.types";

interface FlowValidationConfig<FK extends string, Slug extends string> {
  getState: () => { cats: Record<string, TCatFormDataInput> };
  errorStore: IErrorStore<FK, Slug>;
  fieldRules: Record<string, ValidationRule[]>;
  requiredFieldsBySlug: Record<Slug, (data: RequiredFieldData) => FK[]>;
  isUserPage: (slug: Slug) => boolean;
}

export function createFlowValidation<FK extends string, Slug extends string>(
  config: FlowValidationConfig<FK, Slug>,
) {
  const validateField = createFieldValidator<FK, Slug>(
    config.errorStore,
    config.fieldRules,
  );

  const getRequiredFieldsForSlug = (
    slug: Slug,
    context?: Pick<RequiredFieldData, "inABTestGroup">,
  ): FK[] => {
    const getFieldsForSlug = config.requiredFieldsBySlug[slug];
    const { inABTestGroup } = context ?? {};

    if (config.isUserPage(slug)) {
      return getFieldsForSlug({ inABTestGroup });
    }

    const { cats } = config.getState();
    const requiredFields: FK[] = [];

    for (const [ catId, cat ] of Object.entries(cats)) {
      if (!cat.softDelete) {
        const catFields = getFieldsForSlug({ cat, catId, inABTestGroup });
        requiredFields.push(...catFields);
      }
    }

    return requiredFields;
  };

  return { validateField, getRequiredFieldsForSlug };
}
